import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import Tab from '../../../components/Tabs/tabs.component';
import VisualizarAnalise from '../../alertas/cadastroAnalise/visualizarCadastroAnalise.page';
import VisualizarAudiencia from '../../alertas/CadastroAudiencia/visualizarAudiencia.page';
import VisualizarDadosParametrizados from '../../alertas/cadastroDadosParametrizados/visualizarDadosParametrizados.page';
import VisualizarGeo from '../../alertas/CadastroGeo/visualizarGeo.page';

export default class TabNavigation extends Component {
	state = {
		activeTab: '',
	};

	componentDidMount() {
		const url = window.location.href.substr(window.location.href);
		const tab = url.split('/');
		const tamanho = tab.length - 1;
		this.setState({
			activeTab: tab[tamanho - 1],
		});
	}

	getParams() {
		return window.location.href.substr(
			window.location.href.lastIndexOf('/') + 1,
		);
	}

	handleClick = (valor) => {
		this.setState({
			activeTab: valor,
		});
		const { history } = this.props;
		history.push(`/visualizarAlerta/${valor}/${this.getParams()}`);
	};

	handleBackButton = () => {
		const { history } = this.props;
		history.push('/alertas');
	};

	render() {
		const { match: { path } } = this.props;
		const { activeTab } = this.state;

		return (
			<div className='card container mt-5'>
				<div className='card-body'>
					<div className='tabs custom-tab'>
						<nav>
							<ul>
								<Tab
									label='Dados parametrizados'
									valor='dados'
									activeTab={activeTab}
									onClick={() => this.handleClick('dados')}
									icon='dados'
								/>
								<Tab
									label='Geo'
									valor='geo'
									activeTab={activeTab}
									onClick={() => this.handleClick('geo')}
									icon='globe'
								/>
								<Tab
									label='Análise'
									valor='analise'
									activeTab={activeTab}
									onClick={() => this.handleClick('analise')}
									icon='analytics'
								/>
								<Tab
									label='Audiência'
									valor='audiencia'
									activeTab={activeTab}
									onClick={() => this.handleClick('audiencia')}
									icon='audiencia'
								/>
							</ul>
						</nav>
						<div>
							<Switch>
								<Route
									path={`${path}/dados/:id`}
									exact
									render={() => (
										<VisualizarDadosParametrizados
											onClick={this.handleClick}
											alertaId={this.getParams()}
											className='section-dados'
											handleBackButton={this.handleBackButton}
										/>
									)}
								/>
								<Route
									path={`${path}/geo/:id`}
									render={() => (
										<VisualizarGeo
											onClick={this.handleClick}
											alertaId={this.getParams()}
											className='section-geo'
											handleBackButton={this.handleBackButton}
										/>
									)}
								/>
								<Route
									path={`${path}/analise/:id`}
									render={() => (
										<VisualizarAnalise
											onClick={this.handleClick}
											alertaId={this.getParams()}
											className='section-analise'
											handleBackButton={this.handleBackButton}
										/>
									)}
								/>
								<Route
									path={`${path}/audiencia/:id`}
									render={() => (
										<VisualizarAudiencia
											onClick={this.handleClick}
											alertaId={this.getParams()}
											className='section-audiencia'
											handleBackButton={this.handleBackButton}
										/>
									)}
								/>
							</Switch>
						</div>
					</div>
				</div>
			</div>

		);
	}
}
